import MenuDataAnalytics from "../MenuDataAnalytics";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PalavraChaveRfv from "../PalavraChaveRfv";
import PesquisaArtigo from "../PesquisaArtigo";

export default function EnetendoRfv() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/data-analytics">Data Analytics</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Entendendo o RFV: Recência, Frequência e Valor
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuDataAnalytics />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Entendendo o RFV: Recência, Frequência e Valor
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Data Analytics</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Conheça seu cliente
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <figure>
                  <img
                    src="img/entendendo-rfv.png"
                    alt="excel"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                </figure>

                <figcaption>Análise RFV</figcaption>

                <p>
                  O RFV (Recência, Frequência e Valor) é uma estratégia
                  analítica poderosa usada para identificar os clientes mais
                  valiosos de sua base e entender melhor seus padrões de compra.
                  Este modelo divide os clientes em segmentos baseados em três
                  componentes essenciais: Recência, Frequência e Valor. Vamos
                  explorar cada um destes aspectos:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>Recência:</a> Refere-se ao
                    tempo decorrido desde a última compra de um cliente.
                    Clientes que compraram recentemente são mais propensos a
                    voltar a comprar se comparados àqueles cuja última compra
                    foi há mais tempo. Por isso, empresas focam em manter uma
                    baixa recência para aumentar a lealdade do cliente.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>Frequência:</a> Este
                    componente mede quantas vezes um cliente comprou durante um
                    determinado período. Clientes frequentes são muitas vezes
                    mais engajados e menos sensíveis a preços, o que os torna
                    particularmente valiosos para qualquer negócio.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>Valor:</a> O valor
                    representa o total gasto por um cliente ao longo de um
                    período específico. Este indicador ajuda a empresa a
                    identificar quais clientes contribuem mais para a receita.
                  </li>
                </ul>

                <p>
                  A análise RFV classifica seus clientes com base nesses 3
                  componentes e os coloca automaticamente em 10 segmentos
                  comportamentais. Isso mostra seus clientes desde os mais leais
                  e de alto valor (“Campeões”), bem como seus clientes
                  “Hibernantes” (aqueles que fizeram uma ou duas compras, mas
                  não retornaram).
                </p>

                <p>
                  Vamos examinar todos esses segmentos, entender o que eles
                  significam e trazer algumas dicas sobre como envolvê-los:
                </p>

                <p>
                  <h3 id="campeao">Recompense os campeões da sua marca</h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a>{" "}
                  Campeão
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Clientes fiéis
                  de maior valor que pontuam 5 em valor de recência e 4-5 em
                  frequência + valor monetário. Esses são compradores
                  recorrentes que estão obtendo grande valor com seu produto,
                  voltam o tempo todo para gastar muito e provavelmente são
                  evangelistas da marca neste momento.
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  Apesar de seu instinto de deixar esse grupo no piloto
                  automático, já que são compradores frequentes que gastam
                  muito, você definitivamente deveria fazer mais para
                  recompensá-los por sua lealdade.
                </p>

                <p>
                  A relação empresa-cliente é uma via de mão dupla! Se eles
                  estão agregando muito valor ao seu negócio, você deseja
                  retribuir o favor com um tratamento especial. Considerar:{" "}
                </p>

                <ul>
                  <li>Dando-lhes ofertas exclusivas</li>
                  <li>
                    Implementar recompensas de fidelidade ou aumentar suas
                    recompensas de fidelidade
                  </li>
                  <li>Fornecendo-lhes acesso antecipado a novos produtos</li>
                  <li>Convidando-os a deixar um comentário para você</li>
                </ul>

                <p>
                  Demonstrações de boa vontade ajudam muito a melhorar a
                  experiência da marca para seus principais clientes. Divulgue
                  sua apreciação e agregue valor por sua lealdade contínua.
                </p>

                <p>
                  <h3 id="fieis">Encante seus clientes fiéis</h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a>{" "}
                  Consumidor Leal
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Como o nome
                  sugere, este grupo é certamente leal. Eles são o seu segundo
                  grupo de maior valor, logo abaixo dos Campeões da sua marca.
                  Eles têm muito potencial. Pontuar de 3 a 4 em tempo para
                  retorno (o que significa que compraram recentemente) e de 4 a
                  5 em frequência + valor monetário significa que eles são
                  grandes fãs de sua marca. É hora de tratá-los como tal para
                  convertê-los em campeões da marca!
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  Este é outro grupo que você não pode ignorar porque está
                  viciado em seus produtos. A frequência e as pontuações
                  monetárias estão entre as mais altas, mas a atualidade ainda
                  não chegou lá – já faz algum tempo desde que eles compraram.
                  Considere o seguinte para incentivá-los a voltar:
                </p>

                <ul>
                  <li>
                    Apresente suas recompensas de fidelidade de alto nível
                  </li>
                  <li>
                    Convide-os para se inscreverem (se você oferecer
                    assinaturas)
                  </li>
                  <li>Conte a eles sobre lançamentos de novos produtos</li>
                  <li>
                    Convide-os a seguir nas redes sociais para aprimorar a
                    experiência da marca
                  </li>
                </ul>

                <p>
                  Mover o ponteiro para a zona dos campeões significa entregar
                  mensagens personalizadas e ofertas valiosas e oportunas aos
                  seus clientes fiéis. Dica profissional: use os dados da
                  jornada de compra, se os tiver, para identificar o que será
                  mais relevante para mostrar com base em compras anteriores.
                </p>

                <p>
                  <h3 id="lealdade">
                    Incline a balança para possíveis consumidores leais
                  </h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a>{" "}
                  Lealdade em Potencial
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Há MUITO
                  potencial neste grupo (daí o nome)! Seus possíveis
                  consumidores leais compraram recentemente (pontuação de 4 a 5)
                  e estão na faixa de 2 a 3 em termos de frequência e valor
                  monetário. Seus produtos e sua marca estão frescos porque
                  acabaram de fazer uma compra, mas, historicamente, não estão
                  comprando uma quantidade muito alta ou gastando no nível mais
                  alto. É hora de atraí-los para se tornarem mais afiliados à
                  sua marca.
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  Provavelmente não é o momento certo para fazer um monte de
                  upsells ou vendas cruzadas por e-mail para seus possíveis
                  consumidores leais. Eles gostam do seu produto, mas não
                  alcançaram o nível de afinidade ou lealdade que você gostaria
                  com a sua marca. Oferecer descontos pode ou não funcionar
                  aqui.
                </p>

                <p>
                  O melhor caminho nesta fase é fazer com que eles se envolvam
                  com sua marca de uma forma diferente. É aqui que você pode
                  aproveitar sua comunidade online ou presença nas redes
                  sociais. Aqui estão algumas ideias:
                </p>

                <ul>
                  <li>Convide-os a segui-lo nas redes sociais e a agir</li>
                  <li>
                    Pode ser uma maneira divertida e envolvente para eles
                    entenderem que você não está apenas vendendo produtos, mas
                    também aprimorando sua experiência nesse estilo de vida,
                    esporte, hobby, atividade, etc.
                  </li>
                  <li>
                    Crie um incentivo que eles possam desbloquear participando
                    da sua comunidade.
                  </li>
                </ul>

                <p>
                  <h3 id="novos">Dê as boas-vindas aos seus novos clientes</h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a> Novos
                  Consumidores
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Seus novos
                  clientes são um segmento crucial para você impressionar! Eles
                  acabaram de fazer a primeira compra com sua marca; você causou
                  uma impressão suficiente para que eles experimentassem seus
                  produtos, agora é hora de definir expectativas e fazer com que
                  se sintam bem-vindos à experiência de sua marca. O potencial
                  deles é ilimitado se você conseguir conectá-los com ótimos
                  conteúdos e produtos.
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  Dizem que as primeiras impressões são as que ficam. Mas esse
                  cliente já comprou seu produto com base na primeira impressão.
                  A sua 2ª impressão aqui é o que conta e deve começar já no
                  email de confirmação da compra!
                </p>

                <p>
                  Você vai querer acompanhar seus novos clientes logo após a
                  compra inicial para proporcionar-lhes uma ótima experiência de
                  marca. Trata-se de definir o tom do relacionamento,
                  convidá-los a se envolver com mais conteúdo e garantir que
                  saibam que há mais por vir.
                </p>

                <ul>
                  <li>
                    Envie-lhes um e-mail de confirmação que também funciona como
                    um e-mail de boas-vindas
                  </li>
                  <li>
                    Convide-os a aprender mais sobre sua marca por meio de seu
                    blog ou outro conteúdo
                  </li>
                  <li>
                    Peça-lhes que se inscrevam no seu boletim informativo, se
                    você tiver um
                  </li>
                </ul>

                <p>
                  <h3 id="promissores">
                    Descubra mais sobre seus clientes promissores
                  </h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a>{" "}
                  Promissores
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Seu grupo de
                  promissores já passou de novos clientes e você não quer que
                  eles desçam ainda mais na hierarquia. Eles compraram
                  recentemente com uma pontuação de 4, mas sua frequência e
                  valor monetário são 1. Apesar disso, você não quer se
                  contentar com o fato de eles serem clientes únicos. Este pode
                  ser um grupo desafiador para conquistar se eles experimentaram
                  seu produto apenas uma vez, mas temos algumas ideias para
                  melhorar sua experiência.
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  Você precisa de mais informações de seus clientes promissores.
                  Você pode tentar recomendações de produtos ou um desconto para
                  atraí-los de volta, mas provavelmente é uma situação de
                  sucesso ou fracasso. Você provavelmente só tem uma compra para
                  trabalhar, então não tem muitos dados sobre eles (além do
                  canal de marketing de onde vieram , do produto que compraram e
                  talvez de um código de desconto - se usado). Podemos fazer
                  melhor.
                </p>

                <p>Aqui está o que sugerimos para seus clientes promissores:</p>

                <ul>
                  <li>
                    Convide-os a responder a uma pesquisa para desbloquear uma
                    recompensa
                  </li>
                  <li>Torne isso um processo simples</li>
                  <li>
                    Forneça recomendações de produtos com base em sua pesquisa e
                    faça uma oferta que eles certamente usarão
                  </li>
                  <li>
                    Se a pesquisa for muito difícil, peça uma avaliação em troca
                    de uma recompensa; isso traz sua marca de volta à mente e os
                    incentiva a fazer outra compra
                  </li>
                </ul>

                <p>
                  <h3 id="atencao">
                    Envolva seu grupo de atenção às necessidades o mais rápido
                    possível
                  </h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a>{" "}
                  Atenção
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Ok, não há
                  confusão aqui; esses clientes precisam de atenção. Eles estão
                  escorregando na atualidade (marcando 3) e sua frequência +
                  pontuação monetária é de apenas 1-2. Eles provavelmente já
                  experimentaram seu produto uma ou duas vezes, mas não são
                  exatamente o sonho do profissional de marketing de retenção. E
                  se você não alcançá-los logo, eles podem se afastar demais e
                  tornar a montanha um pouco mais difícil de escalar.
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  Provavelmente já faz tempo suficiente desde que eles fizeram
                  uma compra para lançar alguns novos lançamentos. Um e-mail
                  focado no produto que aborda coisas que eles compraram no
                  passado e vê se você consegue misturar tudo para que eles
                  aprendam mais sobre suas ofertas por meio do conteúdo. Tentar:
                </p>

                <ul>
                  <li>
                    Mostrar a eles seus lançamentos mais recentes (ou avisar
                    quando eles forem lançados)
                  </li>
                  <li>
                    Use parte do e-mail para fazer com que eles baixem seu
                    aplicativo, se você tiver um, ou promova um vídeo ou blog
                    que possa ajudar a envolvê-los
                  </li>
                  <li>
                    Convide-os para participar de um evento de compras ao vivo,
                    se você fizer isso
                  </li>
                </ul>

                <p>
                  <h3 id="fugir">Esses clientes estão prestes a fugir</h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a>{" "}
                  Prestes a Fugir
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Equiparamos o
                  cliente com pontuação mais baixa à hibernação (mais sobre isso
                  abaixo); seus clientes prestes a fugir ainda não chegaram lá,
                  mas mostram sinais de que a hora de fugir está chegando um
                  pouco mais cedo. Temos que lutar contra isso.
                </p>

                <p>
                  Eles estão bem no meio: 3 em tempo recente, então não faz
                  muito tempo desde que compraram, e sua frequência + pontuação
                  monetária também é 3. Então, eles compraram uma quantidade
                  sólida de seus produtos.
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  ecomendações de produtos oportunas e baseadas em dados são
                  provavelmente a melhor maneira de reativar seu grupo Prestes a
                  Dormir. Aqui está o que você pode tentar:
                </p>

                <ul>
                  <li>
                    Venda cruzada de produtos complementares com base em compras
                    anteriores.
                  </li>
                  <li>
                    Opções de pacote de argumentos de venda, se você as tiver.
                  </li>
                  <li>
                    Pode ser um pouco improvável, mas informe-os sobre sua
                    assinatura e salve, se tiver.{" "}
                  </li>
                </ul>

                <p>
                  <h3 id="perder">
                    Incentive os clientes que você não pode perder
                  </h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a> Não
                  podemos perdê-los
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Sim… não
                  estamos fazendo rodeios aqui com o nome; você não pode perder
                  esses clientes. Eles pontuam 5 em frequência + valor
                  monetário, o que significa que compraram muito em várias
                  compras. A questão é que eles são 1-2 em termos de tempo
                  recente. Também conhecidos como clientes de alto valor que
                  meio que transformaram você em fantasma!
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  Ofereça um grande desconto. Aproveite suas margens na próxima
                  compra, porque você precisa fazer um grande esforço para
                  trazer esses clientes de volta ao seu ecossistema. A história
                  deles sugere que eles amam o seu produto, então faça uma
                  oferta irrecusável! Algumas dicas:
                </p>

                <ul>
                  <li>Chame a atenção deles com um grande desconto.</li>
                  <li>
                    Agregue valor personalizando onde puder (produtos mostrados
                    no e-mail, etc.).
                  </li>
                  <li>
                    Seu único problema é a atualidade. Portanto, lance uma
                    assinatura, se tiver; as assinaturas eliminam o atrito de
                    fazer com que grandes clientes como esse comprem com mais
                    frequência.
                  </li>
                </ul>

                <p>
                  Trata-se de fazê-los voltar a comprar, para que você possa
                  reavivar o interesse deles em sua marca e abrir a porta para
                  alimentá-los com conteúdo e muito mais para aumentar sua
                  afiliação no futuro.
                </p>

                <p>
                  <h3 id="risco">Convide seus clientes em risco a retornar</h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a> Em
                  Risco
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Outro que vai
                  direto ao ponto. Seus clientes em risco estão perto de
                  desistir completamente de comprar com sua marca. Eles pontuam
                  de 1 a 2 em tempo recente e de 3 a 4 em frequência + valor
                  monetário. Então eles são outro grupo que mostra potencial
                  pelo quanto compraram no passado.
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  com base em sua disposição de gastar no passado, encontre uma
                  maneira de adoçar o negócio, oferecendo-lhes uma das seguintes
                  promoções + conteúdo:
                </p>

                <ul>
                  <li>Produtos novos e relevantes</li>
                  <li>
                    Preços de pacotes especiais, combinando produtos que eles
                    experimentaram no passado com novos produtos complementares
                    que podem convencê-los a voltar sempre
                  </li>
                  <li>
                    Encontre uma maneira de reavivar o interesse deles nos
                    produtos que compraram por meio do conteúdo
                  </li>
                </ul>

                <p>
                  Este é outro grupo que se mostrou incrivelmente promissor, mas
                  que não volta há muito tempo.
                </p>

                <p>
                  <h3 id="hibernando">
                    Reintroduza-se aos clientes em hibernação
                  </h3>
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Nome do segmento:</a>{" "}
                  Hibernando
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>Quem são:</a> Os clientes em
                  hibernação representam o segmento de desempenho mais baixo.
                  Eles pontuam de 1 a 2 em termos de atualidade, frequência e
                  valor monetário. Eles fizeram uma ou duas compras há muito
                  tempo e nunca mais retornaram.
                </p>

                <p>
                  <a style={{ fontWeight: "bold" }}>O que fazer com eles:</a>{" "}
                  Eles são realmente difíceis de comercializar em qualquer
                  capacidade de sucesso com promoções ou produtos específicos.
                  Provavelmente, você precisará se afastar de uma mentalidade
                  transacional e se concentrar apenas em fazer com que eles se
                  familiarizem novamente com sua marca. Compartilhe conteúdo que
                  chamará a atenção e despertará o interesse:
                </p>

                <ul>
                  <li>
                    Compartilhe um vídeo de marca de alto nível que cubra a
                    missão/essência de sua marca
                  </li>
                  <li>
                    Compartilhe uma postagem de blog ou guia que os ajudará a
                    conhecer sua marca
                  </li>
                  <li>
                    Um bom conteúdo “conheça o fundador” ou “conheça a marca”
                    pode ajudar os clientes em hibernação a se reencontrarem.
                  </li>
                  <li>
                    Se a mídia social faz parte da experiência da sua marca,
                    definitivamente dê-lhes o incentivo para segui-lo no
                    Twitter, Instagram, etc., para que possam ser lembrados de
                    você de vez em quando.{" "}
                  </li>
                </ul>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <a>
                <MenuInicioRapido />
              </a>
              <br></br>
              <br></br>
              <small>
                <PalavraChaveRfv />
              </small>
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
